const base64regex =
  /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

export const decodeBase64 = (base64String: string) => {
  const parsedUrl = atob(base64String).replace(/[}{"]/g, '').split(',');
  return parsedUrl.reduce<{ [key: string]: string | number | boolean }>(
    (acc, str) => {
      const [key, value] = str.trim().split(':');
      acc[key] =
        key === 'age' ? parseInt(value, 10) : value.trim().toLowerCase();

      return acc;
    },
    {}
  );
};

export const checkIsBase64 = (string: string): boolean => {
  return base64regex.test(string);
};
